import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { inject, onMounted, provide, ref, useSlots } from 'vue';
import { NavItem } from '@/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'NavItem',
  props: {
    title: {},
    depth: {},
    link: {},
    linkTitle: {},
    target: {},
    items: {}
  },
  setup(__props: any) {

const props = __props;


const registerMain = inject<(item: NavItem) => void>('registerMainNavItem');
const registerSub = inject<(item: NavItem) => void>('registerSubNavItem', () => undefined);
const items = ref<NavItem[]>([]);
const slots = useSlots();

provide('registerSubNavItem', registerSubNavItem);

onMounted(() => {
    if (!slots.items || slots.items({}).length === 0) {
        // no sub-items -> register directly
        registerSelf();
    }
});

function registerSubNavItem(item: NavItem) {
    // check depth to only register direct children
    // since provide is passed down to all descendants
    if (item.depth === props.depth + 1) {
        items.value.push(item);
    }
    if (items.value.length === slots.items({}).length) {
        // register after all sub-items have been registered
        registerSelf();
    }
}

function registerSelf() {
    // distinguish main nav items from rest
    if (props.depth === 1) {
        registerMain({ ...props, items: items.value });
    } else {
        registerSub({ ...props, items: items.value });
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "default"),
    _renderSlot(_ctx.$slots, "items")
  ], 64))
}
}

})